import * as angular from "angular";
import {IController, IScope} from "angular";
import {$accountFactory} from "../../$account.factory";

export class ShipperAccountsTableRowCtrl implements IController {

  accountId: string;
  enableRemove: any;

  onSelect: Function;
  onRemove: Function;

  private isMobile: boolean;

  constructor(private $account: $accountFactory, private $scope: IScope, private $mdMedia) {
  }

  $onInit() {
    if (this.accountId) {
      this.$account(this.accountId).$bindCtrlToId(this.$scope, this, 'account', 'accountId');
    }
    this.isMobile = !this.$mdMedia('gt-md');
  }

  $onChanges(changes) {
    if (changes.accountId && !changes.accountId.isFirstChange()) {
      this.$onInit();
    }
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('shipperAccountsTableRow', {
    bindings: {
      accountId: '<',
      enableRemove: '<',
      onSelect: '&',
      onRemove: '&'
    },
    template: require('./shipper-accounts-table-row.html').default,
    controller: ShipperAccountsTableRowCtrl
  });
